import { MessageManagerMessageTypeEnum } from '../shared/services/messages/message.manager.service';

export enum ModalSizeEnum {
  PICCOLA = 'sm',
  MEDIA = 'md',
  GRANDE = 'lg',
  EXTRA_LARGE = 'xl',
}

export enum ModalElementPositionEnum {
  TOP = 'start',
  MIDDLE = 'center',
  BOTTOM = 'end',
}

export interface IGenericModalConfirm {
  crossDismissable?: boolean;
  type?: MessageManagerMessageTypeEnum;
  scrollable?: boolean;
  confirm?: boolean;
  isDetailModal?: boolean;
  onClose?: Function;
  onDismiss?: Function;
  size?: ModalSizeEnum;
  title?: string;
  titleArgs?: {
    [key: string]: string;
  };
  titleHeaderPosition?: ModalElementPositionEnum;
  message?: string;
  messageArgs?: {
    [key: string]: string;
  };
  subMessage?: string;
  id: string;
  onCloseBtnLabel?: string;
  onCloseBtnStyle?: string;
  onDismissBtnLabel?: string;
  closeBtnOnRight?: boolean;
  closeBtnDisabled?: boolean;
  staticBackdrop?: boolean;
  needIcon?: boolean;
  iconPosition?: ModalElementPositionEnum;
  crossDismissableListen?: boolean;
  keyboardActive?: boolean;
  heightBasedOnContent?: boolean;
  fullScreenModalOnMobile?: boolean;
  isCloseBtnDanger?: boolean;
  customSize?: string;
  messageFontSize?: string;
  buttonsOnRight?: boolean;
}
